import { Button } from '@/components/common';
import React from 'react';
import styles from '@/views/Transactions/components/TransactionsTable/TransactionsTableCrypto/TransactionsTableCrypto.module.css';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface RowTxnButtonProps {
  href: string;
  txHash?: string;
}
export const RowTxnButton = ({ href }: RowTxnButtonProps) => {
  const { isDesktop } = useMediaQuery();

  if (href) {
    return (
      <Button
        variants="subtle"
        size={isDesktop ? 'mediumSubtle' : 'smallSubtle'}
        href={href}
        isExternal
        icon="externalLink"
        iconPosition="right"
        className={styles.cellLink}
      >
        View
      </Button>
    );
  }

  return null;
};
